import type { Account } from 'walden-fast/types/fast-backend/account';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_ACCOUNTS: Account = {
  id: '1555',
  uniqueName: 'MonstersINC',
  displayName: 'Monsters Inc.',
  externalIdentifiers: {
    powerBI: {
      masterClientCode: 'mon',
    },
  },
};

export const accountFactory: Factory<Account> = (overrides) => ({
  ...MOCK_ACCOUNTS,
  ...overrides,
});
